import type { RequestConfig } from '@customTypes/index';
import type { PenaltyItemDto } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type GetClubProfilePenaltiesRequest = {
  clubId: string;
};

export type GetClubProfilePenaltiesParams =
  RequestConfig<GetClubProfilePenaltiesRequest>;

export const getClubProfilePenalties = async ({
  params,
  config
}: GetClubProfilePenaltiesParams) =>
  api.get<PenaltyItemDto[]>(
    `/api/ClubProfile/penalties/${params.clubId}`,
    config
  );
